<div class="center-container">
  <div id="container">
    <button (click)="printImage()"> {{ "common.print" | translate | sentenceCase }}</button>
    <img [src]="imageSrc" alt="Image" />
  </div>
</div>
